// extracted by mini-css-extract-plugin
export var index = "index-module--index--NQpS2";